import { get, del, post } from '../../utils/api';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
  GET_TEMPLATE_LIST,
  SET_TEMPLATE_LIST,
  GET_TEMPLATE_LIST_FAILURE,
  DELETE_TEMPLATE_SUCCESS,
  DELETE_TEMPLATE,
  ON_SAVE_SUCCESS,
  ON_SAVE,
} from './actions';
import { toast } from 'react-toastify';
import { handleApiError } from '../../utils/handleApiError';

function* getTemplateList({ payload }) {
  try {
    const { token } = payload;
    const response = yield call(get, `/templates/get`, token);
    const status = response.status;

    let templates = [];
    if (status === 200) {
      templates =
        response.data?.templates?.map((t) => ({
          ...t,
          command: t.command || '',
          output: t.output || '',
        })) || [];
    } else if (status === 404) {
      templates = [];
    } else {
      throw new Error('Unexpected status code');
    }

    yield put({ type: SET_TEMPLATE_LIST, payload: templates });
  } catch (error) {
    if (error?.response?.status !== 404) {
    } else {
      yield put({ type: SET_TEMPLATE_LIST, payload: [] });
    }
  }
}

function* deleteTemplate({ payload }) {
  try {
    const { token, rowData } = payload;
    const ids = { templatesIds: [rowData.id] };
    yield call(del, `/templates/delete`, token, ids);
    yield put({ type: DELETE_TEMPLATE_SUCCESS, payload: rowData.id });
    toast.info(`Template Deleted!`);
  } catch (error) {
    yield handleApiError(error, GET_TEMPLATE_LIST_FAILURE);
  }
}

function* callOnSave({ payload }) {
  try {
    const { token, postData, successCallback } = payload;
    const response = yield call(
      post,
      `/templates/create-or-update`,
      postData,
      token
    );
    const savedTemplate = {
      ...postData,
      id: response.data.id,
      updated_at: response.data.updated_at || new Date().toISOString(),
      command: postData.command || '',
      output: postData.output || '',
    };
    successCallback(savedTemplate);
    yield put({ type: ON_SAVE_SUCCESS });
    if (postData.templateId) {
      toast.info(`Template Updated!`);
    } else {
      toast.info(`Template Saved!`);
    }
  } catch (error) {
    yield handleApiError(error, GET_TEMPLATE_LIST_FAILURE);
  }
}

export default [
  takeEvery(GET_TEMPLATE_LIST, getTemplateList),
  takeEvery(DELETE_TEMPLATE, deleteTemplate),
  takeEvery(ON_SAVE, callOnSave),
];
